import { useQueries, useQueryClient } from '@tanstack/react-query';
import { AdminVideo } from '../common/model/dto/video/admin-video';
import { getVideo } from '../services/admin/admin-video.service';
import {
  applyVideoUpdate,
  invalidateVideoQueries,
} from '../common/utils/video-query-cache';
import {
  hasChanged,
  isAwaitingChange,
  isSwap,
} from '../common/utils/video-status-utils';

export const VIDEO_STATUS_POLL_MS = 20000;

export function useVideoStatusPolling(videos: AdminVideo[]): void {
  const queryClient = useQueryClient();

  useQueries({
    queries: videos.filter(isAwaitingChange).map((video) => ({
      queryKey: ['admin-video-status', video.id],
      queryFn: async () => {
        const latest = await getVideo(video.id);

        if (isSwap(video, latest)) {
          await invalidateVideoQueries(queryClient);
        } else if (hasChanged(video, latest)) {
          applyVideoUpdate(queryClient, latest);
        }

        return latest;
      },
      initialData: video,
      staleTime: VIDEO_STATUS_POLL_MS,
      refetchInterval: VIDEO_STATUS_POLL_MS,
      gcTime: 0,
    })),
  });
}
